import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useAccount } from "wagmi";
import { useChainModal } from "@rainbow-me/rainbowkit";
import Model from "../Model";
import ClosePNG from "../../assets/image/header/close1@2x.png";
import DisconnectPNG from "../../assets/image/header/disconnect@2x.png";
import CopyPNG from "../../assets/image/header/copy.png";
import CopyedPNG from "../../assets/image/header/copyed.png";
import useCopyClipboard from "../../hooks/useCopyClipboard";
import { walletConfig } from "../walletManager/walletConfig";
import { instance } from "../../index";
import { formatUnits } from "viem";
import { disconnect, getAccount, getBalance } from "@wagmi/core";
import { ShowHandleNumber } from "../../utils";
const WalletAddress = ({ address }) => {
    const [isCopied, setCopied] = useCopyClipboard();
    return (_jsxs(WalletAddressWrapper, { children: [_jsx(WalletAddressText, { children: address }), _jsx(CopyIcon, { src: isCopied ? CopyedPNG : CopyPNG, alt: "Copy wallet address", onClick: () => {
                    setCopied(address);
                } })] }));
};
const Balance = ({ label, value }) => {
    return (_jsxs(BalanceWrapper, { children: [_jsx(BalanceLabel, { className: "label", children: label }), _jsx(BalanceValue, { className: "value", children: ShowHandleNumber(value, 4) })] }));
};
export default function AccountModel({ isOpen, onDismiss }) {
    const app = instance.root;
    const { address, chainId, chain } = useAccount();
    const { openChainModal } = useChainModal();
    const [activeChain, setActiveChain] = useState();
    const [chainScan, setChainScan] = useState();
    const [nativeCurrency, setNativeCurrency] = useState();
    const [balance, setBalance] = useState('0');
    // 直接调用 wagmi 的 getBalance 方法获取余额
    const fetchBalance = async () => {
        if (!address) {
            setBalance('0');
            return;
        }
        if (!chainId) {
            setBalance('0');
            return;
        }
        try {
            // 构建余额查询参数
            const balanceParams = {
                address: address,
            };
            // 如果有 chainId，添加 chainId 参数
            if (chainId) {
                balanceParams.chainId = chainId;
            }
            // 直接调用 wagmi 的 getBalance（不传 token 参数，获取原生代币余额）
            const balance = await getBalance(walletConfig, balanceParams);
            // 格式化并设置余额
            if (balance && balance.value !== undefined && balance.decimals !== undefined) {
                // balance.value 是 bigint，直接传给 formatUnits
                const formattedBalance = formatUnits(balance.value, balance.decimals);
                setBalance(formattedBalance);
            }
            else {
                setBalance('0');
            }
        }
        catch (error) {
            setBalance('0');
        }
    };
    useEffect(() => {
        if (chain) {
            setActiveChain(() => {
                return chain;
            });
            setChainScan(() => {
                return chain.blockExplorers?.default;
            });
            setNativeCurrency(() => {
                return chain.nativeCurrency;
            });
        }
        else if (chainId) {
            let _activeChain = walletConfig.chains.find((item) => item.id === chainId);
            if (_activeChain) {
                setActiveChain(_activeChain);
                setChainScan(_activeChain.blockExplorers?.default);
                setNativeCurrency(_activeChain.nativeCurrency);
            }
        }
        if (!address) {
            onDismiss();
        }
        return () => { };
    }, [chain, chainId, address, onDismiss]);
    // 监听模态框打开和链变化，直接获取原生货币余额
    useEffect(() => {
        // 当弹框打开且有地址和链信息时，直接获取余额
        if (isOpen && address && chainId) {
            // 模态框打开或链变化时，先重置余额为 '0'，然后重新获取
            setBalance('0'); // 重置余额为加载状态
            fetchBalance();
        }
    }, [isOpen, address, chainId]); // 监听弹框状态、地址和链变化
    // 不再需要事件监听器，因为直接调用 getBalance 方法
    const handleSwitchChain = () => {
        if (openChainModal) {
            openChainModal();
        }
    };
    return (_jsx(Model, { isOpen: isOpen, onDismiss: onDismiss, children: _jsxs(WalletContainer, { children: [_jsx(WalletHeader, { children: "My wallet" }), _jsx(SettingsIcon, { src: ClosePNG, alt: "Wallet settings", onClick: onDismiss }), _jsxs(WalletContent, { children: [_jsx(WalletAddressLabel, { children: "Wallet Address" }), _jsx(WalletAddress, { address: address?.toString() || '' }), _jsxs(NetworkWrapper, { children: [_jsxs(NetworkInner, { onClick: handleSwitchChain, children: [activeChain?.icon && _jsx(ChainIconImg, { src: activeChain.icon, alt: activeChain?.name }), activeChain?.name] }), _jsxs(TokenInner, { children: [_jsx("a", { href: chainScan?.url + '/address/' + address, target: "_blank", children: chainScan?.name }), activeChain?.scanLogo && _jsx(ChainIconImg, { src: activeChain.scanLogo, alt: chainScan?.name })] })] }), _jsx(BalanceLabels, { children: _jsx(Balance, { label: `${nativeCurrency?.symbol} Balance`, value: balance }) }), _jsxs(DisconnectButton, { onClick: async () => {
                                try {
                                    const account = getAccount(walletConfig);
                                    if (account?.connector) {
                                        await disconnect(walletConfig, {
                                            connector: account.connector
                                        });
                                    }
                                }
                                catch (error) {
                                    // Silent error handling
                                }
                                onDismiss();
                            }, children: [_jsx(DisconnectIcon, { src: DisconnectPNG, alt: "Disconnect wallet" }), _jsx(DisconnectText, { children: "Disconnect Wallet" })] })] })] }) }));
}
;
const WalletContainer = styled.div `
  width: 540rem;
  height: fit-content;
  background: #1C1C20;
backdrop-filter: blur(29rem);

  border-radius: 24rem;
  padding: 32rem;
  position: relative;
  font-family: var(--netx-font);

  @media screen and (max-width: 720px) {
    width: min(343rem, calc(100vw - 32rem));
    border-radius: 16rem;
    padding: 24rem 20rem;
  }
`;
const WalletCard = styled.div `
  background-color: #1c1c20;
  border-radius: 8rem;
  display: flex;
  flex-direction: column;
  padding: 32rem 0;
  width: 100%;

  @media (max-width: 991px) {
    max-width: 100%;
  }
`;
const WalletHeader = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: var(--netx-font);
  font-weight: bold;
  font-size: 20rem;
  color: #fff;
  line-height: 20rem;
  text-align: left;
  font-style: normal;

  @media screen and (max-width: 720px) {
    font-size: 18rem;
    line-height: 22rem;
  }
`;
const NetworkInner = styled.div `
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  height: 36rem;
  background-color: #2D323D;
  border-radius: 8rem;
  padding: 8rem 12rem;
  font-family: var(--netx-font);
  font-weight: 500;
  font-size: 16rem;
  color: #fff;
  line-height: 16rem;
  text-align: left;
  font-style: normal;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  @media screen and (max-width: 720px) {
    flex: 1 1 auto;
    width: auto;
    height: 34rem;
    max-width: 100%;
    padding: 7rem 10rem;
    font-size: 14rem;
    line-height: 16rem;
  }
`;
const ChainIconImg = styled.img `
  display: block;
  width: 20rem;
  height: 20rem;
  overflow: hidden;
  margin-right: 8rem;
  flex: none;

  @media screen and (max-width: 720px) {
    width: 18rem;
    height: 18rem;
    margin-right: 6rem;
  }
`;
const TokenInner = styled.div `
  display: flex;
  align-items: center;
  min-width: 0;

  a {
    cursor: pointer;
    color: #2E6AFF;
    font-family: var(--netx-font);
    font-size: 14rem;
    line-height: 16rem;
    margin-right: 8rem;
    text-decoration: underline;
    white-space: nowrap;
  }

  @media screen and (max-width: 720px) {
    a {
      font-size: 13rem;
      line-height: 16rem;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 120rem;
    }
  }

`;
const WalletTitle = styled.h2 `
  font-family: var(--netx-font);
  margin: 0;
`;
const SettingsIcon = styled.img `
  width: 20rem;
  height: 20rem;
  position: absolute;
  right: 32rem;
  top: 32rem;
  cursor: pointer;

  @media screen and (max-width: 720px) {
    width: 20rem;
    height: 20rem;
    right: 20rem;
    top: 20rem;
  }
`;
const WalletContent = styled.div `

  padding-top: 32rem;
  width: 100%;

  @media (max-width: 991px) {
    max-width: 100%;
    padding: 0 20rem;
  }

  @media screen and (max-width: 720px) {
    padding: 28rem 0 0;
  }
`;
const WalletAddressLabel = styled.div `
  font-family: var(--netx-font);
  font-weight: 300;
  font-size: 16rem;
  color: #fff;
  margin-bottom: 16rem;

  @media (max-width: 991px) {
    max-width: 100%;
  }

  @media screen and (max-width: 720px) {
    font-size: 14rem;
    line-height: 18rem;
    margin-bottom: 12rem;
  }
`;
const WalletAddressWrapper = styled.div `
  width: 476rem;
  height: 46rem;
  border-radius: 8rem;
  border: 1rem solid #353945;
  padding: 0 12rem;
  display: flex;
  align-items: center;
  justify-content: space-between;


  @media (max-width: 991px) {
    max-width: 100%;
    white-space: initial;
  }

  @media screen and (max-width: 720px) {
    width: 100%;
    height: 44rem;
    padding: 0 10rem;
  }
`;
const WalletAddressText = styled.span `
  font-family: var(--netx-font);
  font-weight: 500;
  font-size: 14rem;
  color: #D8D8D8;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
const CopyIcon = styled.img `
  width: 16rem;
  height: 16rem;
  cursor: pointer;
`;
const NetworkWrapper = styled.div `
  height: 36rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 24rem 0;
  gap: 12rem;

  @media screen and (max-width: 720px) {
    height: auto;
    margin: 20rem 0;
    gap: 10rem;
  }
`;
const NetworkIcon = styled.img `
  aspect-ratio: 1;
  object-fit: auto;
  object-position: center;
  width: 20rem;
`;
const NetworkName = styled.span `

`;
const TokenText = styled.a `
  text-decoration: underline;
  font-family: var(--netx-font);
  font-weight: 500;
  font-size: 14rem;
  color: #59FFEB;
  text-decoration-color: #59FFEB;
  cursor: pointer;
  margin-right: 8rem;
`;
const TokenIcon = styled.img `
  width: 20rem;
  height: 20rem;
  margin-left: 8rem;
`;
const BalancesWrapper = styled.div `
  display: flex;
  justify-content: space-between;
`;
const BalanceLabels = styled.div `
  width: 100%;
`;
const BalanceValues = styled.div `
  color: #fff;
  display: flex;
  flex-direction: column;
  font-weight: 500;
  white-space: nowrap;

  @media (max-width: 991px) {
    white-space: initial;
  }
`;
const BalanceWrapper = styled.div `
  display: flex;
  height: 14rem;
  align-items: center;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24rem;

  @media screen and (max-width: 720px) {
    height: auto;
    margin-bottom: 20rem;
  }
`;
const BalanceLabel = styled.span `
  font-family: var(--netx-font);
  font-weight: 300;
  font-size: 14rem;
  color: #718096;

  @media screen and (max-width: 720px) {
    font-size: 13rem;
    line-height: 16rem;
  }

`;
const BalanceValue = styled.span `
  font-family: var(--netx-font);
  font-weight: 500;
  font-size: 14rem;
  color: #fff;
  min-width: 0;
  max-width: 160rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  @media screen and (max-width: 720px) {
    font-size: 13rem;
    line-height: 16rem;
    max-width: 150rem;
  }
`;
const DisconnectButton = styled.div `
  width: 100%;
  height: 52rem;
  border-radius: 8rem;
  border: 1rem solid rgba(46, 106, 255, 1);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  @media (max-width: 991px) {
    max-width: 100%;
    padding: 0 20rem;
  }

  @media screen and (max-width: 720px) {
    height: 48rem;
    border-radius: 10rem;
  }
`;
const DisconnectIcon = styled.img `
  width: 16rem;
  height: 16rem;
  margin-right: 8rem;

`;
const DisconnectText = styled.span `
  font-family: var(--netx-font);
  font-weight: 500;
  font-size: 16rem;
  line-height: 16rem;
  color: rgba(46, 106, 255, 1);

  @media screen and (max-width: 720px) {
    font-size: 15rem;
    line-height: 16rem;
  }
`;
